<form id="inputFactoryForm" [formGroup]="form" autocomplete="off">
  <div class="row">
    <label class="col-5 d-flex align-items-center control-label">
      <span class="label text-truncate">{{label}}</span><span [ngClass]="{'required': isRequired}"></span>
    </label>
    <div class="col-7">
      @switch (inputType) {
        @case (InputType.Input) {
          <input
               id="value"
               name="value"
               type="text"
               autocomplete="off"
               class="form-control"
               formControlName="value">
        }
        @case (InputType.Float) {
          <input
               id="value"
               name="value"
               type="number"
               autocomplete="off"
               class="form-control"
               formControlName="value">
        }
        @case (InputType.Bool) {
          <app-yes-no-group-button
                                 [formControl]="formControlValue"></app-yes-no-group-button>
        }
        @case (InputType.Integer) {
          <input
               id="value"
               name="value"
               autocomplete="off"
               class="form-control"
               type="number"
               formControlName="value">
        }
        @case (InputType.Select) {
          <ejs-dropdownlist
                          id="value"
                          [dataSource]="dropdownValues"
                          [fields]="dropdownSettings"
                          [showClearButton]="true"
                          formControlName="value"></ejs-dropdownlist>
        }
      }
      <app-error-messages [control]="form.controls.value" [showUntouchedErrors]="showUntouchedErrors"></app-error-messages>
    </div>
  </div>
</form>


